var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{staticClass:"button is-info is-light is-small is-outline is-rounded",attrs:{"to":{
      name: 'bankaccountlisting',
      params: {
        id: _vm.id,
        finInstBankName: _vm.finInstBankName
      }
    }}},[_vm._v("Details")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }